import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CalendarImportIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CalendarImportIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CalendarImportIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CalendarImportIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      data-testid="CalendarImportIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M5.25 1.5V3h7.5V1.5h1.5V3H15a1.5 1.5 0 0 1 1.5 1.5v3.75H15v-1.5H3V15h6v1.5H3A1.5 1.5 0 0 1 1.5 15V4.5A1.5 1.5 0 0 1 3 3h.75V1.5z"
        clipRule="evenodd"
      />
      <path d="M12.75 13.5v3h1.5v-3h2.25l-3-3-3 3z" />
    </svg>
  )
);
CalendarImportIcon.displayName = "CalendarImportIcon";
export default CalendarImportIcon;
